<template>
  <div class="facility-container">
    <div class="facility-content">
      <img
        ref="image"
        src="../../assets/FacilityMap2x.png"
      >
    </div>
    <div class="facility-buttons">
      <div
        v-for="button in buttons"
        :key="button.text"
        class="facility-button"
        @click="goTo(button.path)"
      >
        {{ button.text }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Zoomable from '../../mixins/zoomable'

export default {
  name: 'FacilityContent',

  mixins: [Zoomable],

  data() {
    return {
      buttons: [
        { text: 'RM 101A' },
        { text: 'RM 102A' },
        { text: 'RM 103A' },
        { text: 'RM 104A' },
        { text: 'RM 105A', path: 'Room105A' },
        { text: 'RM 201B' },
        { text: 'RM 202B' },
        { text: 'RM 203B' },
        { text: 'RM 204B' },
        { text: 'RM 205B' },
        { text: 'RM 301C' },
        { text: 'RM 302C' },
        { text: 'RM 303C' },
        { text: 'RM 304C' },
        { text: 'RM 305C' },
        { text: 'REC ROOM' },
        { text: 'D DORMS' },
        { text: 'CANTINA' },
        { text: 'KITCHEN' },
        { text: 'STOCK RM' },
        { text: 'STORAGE' },
        { text: 'CHAPEL' },
        { text: 'MED RM' },
        { text: 'DREAD RM' },
        { text: 'COUNCIL MEETING RM' },
        { text: 'COUNCIL LONGE' },
        { text: 'P.A.T.R.I.C.I.A. SERVER' },
        { text: 'CHEM LAB' },
        { text: 'BOTANY LAB' },
        { text: 'HAMZAT STORAGE' },
        { text: 'DECONTAMINATION ROOM' },
      ],
    }
  },

  methods: {
    ...mapActions({
      showPermissionPending: 'auth/showPermissionPending',
    }),

    goTo(name) {
      if (!name) {
        return this.showPermissionPending()
      }

      this.$router.push({ name, params: { enableBack: true } })
    },
  },
}
</script>

<style lang="postcss" scoped>
.facility {
  &-container {
    @apply h-full;
  }

  &-content {
    height: calc(100% - 210px);
    @apply overflow-scroll text-center;
  }

  &-buttons {
    height: 200px;
    @apply flex flex-col items-start justify-start flex-wrap overflow-scroll;
  }

  &-button {
    font-family: 'input-mono';
    width: 210px;
    @apply border border-blue py-1 text-blue uppercase flex justify-center mr-2 mt-2 text-sm cursor-pointer;
    &:hover {
      @apply bg-blue text-blue-lighter;
    }
  }
}

img {
  max-width: 10000px;
}
</style>
